'use strict';

var UserExclusionsPanelController = function UserExclusionsPanelController($scope, SystemConstants) {
  $scope.mode = null;
  $scope.$on('user-exclusions:modeChanged', function (event, mode) {
    $scope.mode = mode;
  });
  $scope.isExclusionRulesScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.USER_EXCLUSIONS.EXCLUSION_RULES;
  };
  $scope.isFbcExclusionRulesScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.USER_EXCLUSIONS.FBC_EXCLUSION_RULES;
  };
  $scope.isFareExclusionRulesScreen = function () {
    return $scope.mode === SystemConstants.SCREEN_VALUE.USER_EXCLUSIONS.FARE_EXCLUSION_RULES;
  };
};
UserExclusionsPanelController.$inject = ['$scope', 'SystemConstants'];
module.exports = UserExclusionsPanelController;